jQuery(document).ready(function($){


// Collection page range cards 



          $('.range-tabs__scroller').slick({
  dots: false,
  arrows: false,
  infinite: false,      // <-- ye sabse zaroori change. left flush, right peek
  speed: 300,
  slidesToShow: 6.2,    // 6 pure + right me 0.2 peek
  slidesToScroll: 1,
  responsive: [
    { breakpoint: 1024, settings: { slidesToShow: 5.3, slidesToScroll: 1 } },
    { breakpoint: 600,  settings: { slidesToShow: 4.3, slidesToScroll: 1 } },
    { breakpoint: 480,  settings: { slidesToShow: 3.3, slidesToScroll: 1 } }
  ]
});




 $("product-block").each(function(){
    var product_image = $(this).find(".image-label-wrap");
    $(this).find("span.offer-price").appendTo(product_image);

 })

 
 
    function checkWidth() {
        var windowSize = $(window).width();

        if (windowSize <= 767) {
           $('.custom_collection_section .product-grid').slick({
  dots: true,
  arrows: false,
  infinite: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  autoplay: true,
  autoplaySpeed: 4000,
   centerMode: false,
  centerPadding: '40px'
});

      $('nav.coltabs-nav').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  autoplay: false,
  autoplaySpeed: 4000,
  prevArrow:'<button type="button" class="slick-prev pull-left"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-chevron-right" aria-hidden="true" focusable="false" role="presentation"><path d="m9 18 6-6-6-6"></path></svg></button>',
            nextArrow:'<button type="button" class="slick-next pull-right"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-chevron-right" aria-hidden="true" focusable="false" role="presentation"><path d="m9 18 6-6-6-6"></path></svg></button>'
        
});


        }
    }

    // Execute on load
    checkWidth();
    // Bind event listener
    $(window).resize(checkWidth);



 

 })


 document.addEventListener("DOMContentLoaded", function(){

const modal = document.getElementById("sizeChartModal");
const popup = document.querySelector(".size-chart-container");
const openBtn = document.getElementById("openSizeChart");
const closeBtn = document.querySelector(".size-close");

// OPEN POPUP
if(openBtn){
  openBtn.addEventListener("click", function(){
    modal.style.display = "block";
  });
}

// CLOSE BUTTON
if(closeBtn){
  closeBtn.addEventListener("click", function(){
    modal.style.display = "none";
  });
}

// CLOSE WHEN CLICK OUTSIDE POPUP
modal.addEventListener("click", function(e){
  if(!popup.contains(e.target)){
    modal.style.display = "none";
  }
});


// ----------------------------
// SIZE TABLE CM / INCH SWITCH
// ----------------------------

const table = document.querySelector(".size-table table");

if(table){
  const rows = table.querySelectorAll("tr");

  rows.forEach((row, rowIndex) => {
    if(rowIndex === 0) return;

    const cells = row.querySelectorAll("td");

    cells.forEach((cell, cellIndex) => {
      if(cellIndex === 0) return;

      const rawText = cell.innerText.trim();

      // CHECK IF RANGE (e.g. "70-75" or "70–75")
      const rangeMatch = rawText.match(/^(\d+(?:\.\d+)?)\s*[-–]\s*(\d+(?:\.\d+)?)$/);

      if(rangeMatch){
        // Store both range values
        cell.dataset.cmMin = rangeMatch[1];
        cell.dataset.cmMax = rangeMatch[2];
        cell.dataset.isRange = "true";
      } else {
        const single = parseFloat(rawText);
        if(!isNaN(single)){
          cell.dataset.cm = single;
          cell.dataset.isRange = "false";
        }
      }
    });
  });
}

// tab switch
document.querySelectorAll(".size-tab").forEach(tab => {

  tab.addEventListener("click", function(){

    document.querySelectorAll(".size-tab").forEach(t => t.classList.remove("active"));
    this.classList.add("active");

    const unit = this.dataset.unit;

    if(!table) return;

    const rows = table.querySelectorAll("tr");

    rows.forEach((row, rowIndex) => {
      if(rowIndex === 0) return;

      const cells = row.querySelectorAll("td");

      cells.forEach((cell, cellIndex) => {
        if(cellIndex === 0) return;

        const isRange = cell.dataset.isRange === "true";

        if (isRange) {
  var cmMin = parseFloat(cell.dataset.cmMin);
  var cmMax = parseFloat(cell.dataset.cmMax);

  if (unit === 'inch') {
    cell.innerText = Math.round(cmMin / 2.54) + '-' + Math.round(cmMax / 2.54);
  } else {
    cell.innerText = cmMin + '-' + cmMax;
  }

} else {
  var cm = parseFloat(cell.dataset.cm);
  if (isNaN(cm)) return;

  cell.innerText = unit === 'inch'
    ? Math.round(cm / 2.54)
    : cm;
}

      });
    });

  });
});

});


// INIT POPUP CAROUSEL
document.querySelector("#sizeChartBtn")?.addEventListener("click", function(){

setTimeout(function(){

document.querySelectorAll(".popup-carousel").forEach(el=>{
if(window.theme && window.theme.slider){
window.theme.slider.init(el);
}
});

},300);

});